export default __webpack_public_path__ + "static/Image-Providing-Access-to-Healthy-Food-c88b71992ece49acd31d22857bf0c0b7.jpg";